import React from "react";

function TableCell({ id, className = "", onClick, children, ...rest }) {
  return (
    <td id={id} className={className} onClick={onClick} {...rest}>
      {children}
    </td>
  );
}

export default TableCell;